export var isEligibilityStale = function isEligibilityStale(eligibility) {
  return eligibility === undefined || (eligibility === null || eligibility === void 0 ? void 0 : eligibility.status) === 'expired';
};
//# sourceMappingURL=isEligibilityStale.js.map